import { render, staticRenderFns } from "./ActionEditor.vue?vue&type=template&id=2885cbac"
import script from "./ActionEditor.vue?vue&type=script&lang=js"
export * from "./ActionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports